import React from 'react';
import { cx } from './utils';

const Button = ({
  as: Comp = 'button',
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  ...props
}) => {
  const variants = {
    primary: 'bg-[#1F2A37] text-white hover:bg-[#111827] shadow-sm',
    outline: 'border border-slate-200 text-slate-700 hover:border-slate-300 hover:text-slate-900',
    ghost: 'text-slate-600 hover:text-slate-900 hover:bg-slate-100',
    light: 'bg-white text-slate-700 hover:text-slate-900 border border-slate-200',
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-6 py-3 text-sm',
  };

  return (
    <Comp
      className={cx(
        'inline-flex items-center justify-center rounded-full font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F4EADF] disabled:cursor-not-allowed disabled:opacity-60',
        variants[variant] || variants.primary,
        sizes[size] || sizes.md,
        className
      )}
      disabled={disabled}
      {...props}
    />
  );
};

export default Button;
